import {
  createTheme,
  MantineColorsTuple,
  MantineThemeOverride,
} from "@mantine/core";
import { DatesProviderSettings } from "@mantine/dates";

/**
 * The brand ramp as Mantine indexes it: 0-9 mapped onto `--color-brand-50`…900,
 * so index 6 is `--color-brand-600` — the blue `<Button variant="primary">`
 * already paints. The values are `var()` references on purpose: `libs/theme`
 * stays the single place a colour is declared, and Mantine derives the rest
 * (hover, light, outline) from them with `color-mix`.
 */
export const BRAND_COLOR_TUPLE: MantineColorsTuple = [
  "var(--color-brand-50)",
  "var(--color-brand-100)",
  "var(--color-brand-200)",
  "var(--color-brand-300)",
  "var(--color-brand-400)",
  "var(--color-brand-500)",
  "var(--color-brand-600)",
  "var(--color-brand-700)",
  "var(--color-brand-800)",
  "var(--color-brand-900)",
];

/** Mirrors `ring-ink-900/12`, the hairline every card and input already uses. */
export const BORDER_COLOR =
  "color-mix(in oklch, var(--color-ink-900) 12%, transparent)";

export const MANTINE_THEME: MantineThemeOverride = createTheme({
  colors: { brand: BRAND_COLOR_TUPLE },
  primaryColor: "brand",
  // 600 in both schemes; the app is light-only, but Mantine's dark default (8)
  // would make a stray dark render look nothing like the rest of the product.
  primaryShade: { light: 6, dark: 6 },
  black: "var(--color-ink-900)",
  white: "var(--color-surface)",
  fontFamily: "var(--font-sans)",
  headings: { fontFamily: "var(--font-sans)" },
  defaultRadius: "md",
  cursorType: "pointer",
});

/**
 * Monday first — both interface locales start the week there, and so do ДПС
 * period reports. `locale` is filled in per render from the chosen language.
 */
export const DATES_SETTINGS: DatesProviderSettings = {
  firstDayOfWeek: 1,
  weekendDays: [6, 0],
  consistentWeeks: true,
};

/**
 * How a picked date is shown in the field. Both interface locales are
 * day-first (`uk-UA`, `en-GB`), so one format serves them; the value behind it
 * stays the `YYYY-MM-DD` string every ДПС query is built on.
 */
export const DATE_INPUT_FORMAT = "DD.MM.YYYY";
